import AccordionMini from '@ui/accordion/AccordionMini';
import ModalDialog from '@ui/modal/ModalDialog';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const TfnForAllCountries = (props) => {
    const { t } = useTranslation();
    const [openTfnModal, setOpenTfnModal] = useState(false);
    const [tfnConfig, setTfnConfig] = useState();
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState();
    useEffect(() => {
        api.getTfnForAllCountries().then((data) => {
            if (!data.error) {
                setTfnConfig(data.configuration);
                const regionNamesInEnglish = new Intl.DisplayNames([window.language || 'en'], { type: 'region' });
                let coutryNameOverride = {
                    HK: t('select.option.country.hongkong'),
                    MO: t('select.option.country.macau'),
                    TW: t('select.option.country.taiwan'),
                };
                let countries = Object.keys(data.configuration).map((coutryCode) => {
                    return { code: coutryCode, name: coutryNameOverride[coutryCode] ? coutryNameOverride[coutryCode] : regionNamesInEnglish.of(coutryCode) };
                });
                countries.sort((a, b) => {
                    let textA = a.name.toUpperCase();
                    let textB = b.name.toUpperCase();
                    return textA.localeCompare(textB);
                });
                countries.unshift({ code: 'select', name: t('label.select') });
                setCountries(countries);
            }
        });
    }, []);
    const tfnCommonSection = (inAccordion) => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row spacing" },
            React.createElement("div", { className: inAccordion ? 'col-lg-6 col-md-5 col-sm-6' : 'col-sm-6' },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { id: "location-label", className: "form-group__label", htmlFor: "location" }, t('tfn.location')),
                    React.createElement("div", { className: "form-select" },
                        React.createElement("select", { id: "location", name: "location", className: "form-control", value: selectedCountry, onChange: (e) => {
                                setSelectedCountry(e.target.value);
                            }, onBlur: (e) => {
                                setSelectedCountry(e.target.value);
                            } }, (countries || []).map((c, i) => (React.createElement("option", { key: i, value: c.code }, c.name)))))))),
        selectedCountry && tfnConfig[selectedCountry] && (React.createElement("div", { className: "row spacing" },
            React.createElement("div", { className: inAccordion ? 'col-lg-6 col-md-5 col-sm-6' : 'col-sm-6' },
                React.createElement("p", null, t('tfn.availability', {
                    0: t(`weekdays.${tfnConfig[selectedCountry].from_day.toLowerCase()}`),
                    1: t(`weekdays.${tfnConfig[selectedCountry].to_day.toLowerCase()}`),
                    2: tfnConfig[selectedCountry].from_hour,
                    3: tfnConfig[selectedCountry].to_hour,
                }))),
            React.createElement("div", { className: inAccordion ? 'col-lg-4 offset-lg-2 col-md-6 col-sm-5 offset-sm-1' : 'col-sm-6 col-md-5 offset-md-1' },
                React.createElement("a", { className: "button button--secondary call", href: `tel:${tfnConfig[selectedCountry].phone}` }, tfnConfig[selectedCountry].phone))))));
    return (props === null || props === void 0 ? void 0 : props.accordion) ? (React.createElement(AccordionMini, { id: "tfn-accordion", title: t('contacts.tfnforallcountries') },
        React.createElement("p", null, t('tfn.chooselocationshort')),
        tfnCommonSection(true))) : (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "tfn-toggle", "aria-haspopup": "dialog", onClick: () => {
                setOpenTfnModal(true);
            } }, t('contacts.tfnforallcountries')),
        React.createElement(ModalDialog, { role: "dialog", isOpen: openTfnModal && !!tfnConfig, onRequestClose: () => setOpenTfnModal(false), hasDivisor: true, contentLabel: t('clientservice.callus'), className: "tfn-modal" },
            React.createElement(React.Fragment, null,
                React.createElement("p", null, t('tfn.chooselocation')),
                tfnCommonSection()))));
};
export default TfnForAllCountries;
